export interface ModuleResourceIdResponseApi {
  moduleResourceId: string;
}

export let isModuleResourceIdResponseDTO = (
  variable: unknown
): variable is ModuleResourceIdResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "moduleResourceId" in variable &&
    typeof variable.moduleResourceId === "string"
  );
};
